import React from 'react';

// Portal-shell skeleton shown while lazy route chunks load.
const LoadingFallback = () => (
  <div className="portal-loading" aria-busy="true" aria-label="Loading page">
    <div className="portal-loading__header" />
    <div className="portal-loading__body" />
  </div>
);

export default LoadingFallback;
